import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import ComercialChip from './ComercialChip'

// The 409 posibles_duplicados warning: the matches the server found, each one
// openable, and the choice to go back and review or to save anyway (the form
// then sends confirmar_duplicados: true). Duplicates never block.
//   tipo: 'org' (matches by name: { id, nombre_comercial, ruta, archivada })
//         | 'contacto' (matches by email: { id, nombre_completo, correo, organizaciones, archivado })
//   enLinea: drawn inside the form (a form in the side panel) instead of in a modal.
//   texto: what the warning says, when not the default for its tipo (a contact's
//          matches by name, found by the form itself).
// As a modal it is marked data-comercial-modal so a ComercialPanel under it leaves Esc to it.
export default function ComercialAvisoDuplicados({ enLinea, ...props }) {
  const { t } = useTranslation('comercial')
  if (enLinea) {
    return (
      <div role="alert" className="rounded-xl border border-amber-200 bg-amber-50 p-4">
        <p className="text-sm font-semibold text-amber-900">{t('duplicados.titulo')}</p>
        <Contenido {...props} />
      </div>
    )
  }
  return (
    <div data-comercial-modal>
      <Modal title={t('duplicados.titulo')} onClose={props.onRevisar} wide>
        <Contenido {...props} />
      </Modal>
    </div>
  )
}

function Contenido({ tipo, texto, coincidencias, onAbrir, onRevisar, onGuardarIgual, guardando }) {
  const { t } = useTranslation('comercial')
  return (
    <>
      <p className="text-sm text-gray-600">{texto || t(tipo === 'org' ? 'duplicados.textoOrg' : 'duplicados.textoContacto')}</p>
      <ul className="mt-3 divide-y divide-gray-100 border border-gray-100 rounded-lg max-h-72 overflow-y-auto bg-white">
        {coincidencias.map(c => (
          <li key={c.id} className="px-3 py-2 flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{tipo === 'org' ? c.nombre_comercial : c.nombre_completo}</p>
              <p className="text-xs text-gray-500 truncate">
                {tipo === 'org' ? c.ruta : [c.correo, ...(c.organizaciones || [])].filter(Boolean).join(' · ')}
              </p>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {(c.archivada || c.archivado) && <ComercialChip variante="archivado">{t('chips.archivado')}</ComercialChip>}
              {onAbrir && (
                <button type="button" onClick={() => onAbrir(c.id)} className="text-xs text-gray-600 underline hover:text-gray-900">
                  {t('duplicados.ver')}
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <button type="button" onClick={onRevisar}
          className="px-4 py-2 rounded-lg text-sm border border-gray-200 bg-white text-gray-700 hover:bg-gray-50">
          {t('duplicados.revisar')}
        </button>
        <button type="button" onClick={onGuardarIgual} disabled={guardando}
          className="px-4 py-2 rounded-lg text-sm bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-40">
          {t('duplicados.guardarIgual')}
        </button>
      </div>
    </>
  )
}
